export { default } from "./permission-summary";
